var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSplitScreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentFill",
    d: "M30.2857143,9.71428571 L30.2857143,54.2857143 C30.2857143,55.232 31.0537143,56 32,56 C32.9462857,56 33.7142857,55.232 33.7142857,54.2857143 L33.7142857,9.71428571 C33.7142857,8.768 32.9462857,8 32,8 C31.0537143,8 30.2857143,8.768 30.2857143,9.71428571 Z M26.8571429,13.1428571 L13.1428571,13.1428571 C11.7782857,13.1428571 10.4702857,13.6845714 9.50685714,14.6497143 C8.54171429,15.6131429 8,16.9211429 8,18.2857143 L8,45.7142857 C8,47.0788571 8.54171429,48.3868571 9.50685714,49.3502857 C10.4702857,50.3154286 11.7782857,50.8571429 13.1428571,50.8571429 L26.8571429,50.8571429 L26.8571429,13.1428571 Z M37.1428571,13.1428571 L37.1428571,50.8571429 L50.8571429,50.8571429 C52.2217143,50.8571429 53.5297143,50.3154286 54.4931429,49.3502857 C55.4582857,48.3868571 56,47.0788571 56,45.7142857 L56,18.2857143 C56,16.9211429 55.4582857,15.6131429 54.4931429,14.6497143 C53.5297143,13.6845714 52.2217143,13.1428571 50.8571429,13.1428571 L37.1428571,13.1428571 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitScreenIcon);
export default __webpack_public_path__ + "static/media/split-screen-icon.081d0e6fde34314299761dde2bbd6b48.svg";
export { ForwardRef as ReactComponent };